import { render, staticRenderFns } from "./InLink.vue?vue&type=template&id=854342c8&scoped=true&"
import script from "./InLink.vue?vue&type=script&lang=js&"
export * from "./InLink.vue?vue&type=script&lang=js&"
import style0 from "./InLink.vue?vue&type=style&index=0&id=854342c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854342c8",
  null
  
)

export default component.exports